import Hotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { Input } from 'antd';
import { RecipientDetails } from './OrderMedicineUtils';
import { CloseBtIcon } from './BookLabTestsUtils';

const AddRecipientModal: React.FC<{
    closeMe: () => void;
    setRecipient: (recipientDetails: RecipientDetails) => void;
    recipientDetails: RecipientDetails;
    numberError: string;
}> = ({ closeMe, setRecipient, recipientDetails, numberError }) => {
    const [formInput, setFormInput] = useState(recipientDetails);

    const formInputChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
        setFormInput({
            ...formInput,
            [id]: value,
        });
    };

    const saveRecipientHandler = () => {
        setRecipient(formInput);
    };
    const { name, mobile, alternative_mobile } = formInput;
    return (
        <Hotkeys keyName="esc">
            <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                style={{ zIndex: 20 }}
                transition={{ duration: 0.2, ease: 'linear' }}
                className="font-lato select-none"
            >
                <div className="modal-overlay" onClick={closeMe}></div>
                <div className="modal-content w-440 font-lato font-400 rounded-8">
                    <div className="h-full flex flex-col">
                        <div className="flex items-center justify-between px-16 py-14 bg-neutral-9 rounded-t-8">
                            <p className="font-700 text-16">Edit Recipient Name</p>
                            <CloseBtIcon closeMe={closeMe} />
                        </div>

                        <div className="flex-1 text-14 px-16 py-14 overflow-auto space-y-14 add-address-form">
                            <div className="flex items-start space-x-12 px-12 py-9 bg-darwin-accent-investigations-ochre-100 border border-darwin-accent-investigations-ochre-500 rounded-8">
                                <svg
                                    className="h-24 w-15 fill-darwin-accent-investigations-ochre-900"
                                    viewBox="0 0 11 15"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M7.99512 11.25C8.24121 10.4023 8.78809 9.63672 9.33496 8.89844C9.47168 8.70703 9.6084 8.51562 9.74512 8.32422C10.292 7.53125 10.6201 6.60156 10.6201 5.58984C10.6201 2.91016 8.45996 0.75 5.80762 0.75C3.12793 0.75 0.995117 2.91016 0.995117 5.5625C0.995117 6.60156 1.2959 7.53125 1.84277 8.32422C1.97949 8.51562 2.11621 8.70703 2.25293 8.89844C2.7998 9.63672 3.34668 10.4023 3.62012 11.25H7.99512ZM5.80762 14.75C7.01074 14.75 7.99512 13.793 7.99512 12.5625V12.125H3.62012V12.5625C3.62012 13.793 4.57715 14.75 5.80762 14.75ZM3.62012 5.5625C3.62012 5.80859 3.40137 6 3.18262 6C2.93652 6 2.74512 5.80859 2.74512 5.5625C2.74512 3.89453 4.1123 2.5 5.80762 2.5C6.02637 2.5 6.24512 2.71875 6.24512 2.9375C6.24512 3.18359 6.02637 3.375 5.80762 3.375C4.57715 3.375 3.62012 4.35938 3.62012 5.5625Z" />
                                </svg>

                                <p>
                                    For this order, the delivery person will contact this number
                                    when delivering the medicines.
                                </p>
                            </div>

                            <div className="space-y-6">
                                <p className="font-700">Recipient Name</p>
                                <Input
                                    id="name"
                                    className="p-10 rounded-8"
                                    placeholder="name"
                                    value={name}
                                    onChange={formInputChangeHandler}
                                    required
                                />
                            </div>

                            <div className="space-y-6">
                                <p className="font-700">Recipient Mobile Number</p>
                                <div className="relative">
                                    <Input
                                        id="mobile"
                                        className="p-10 pl-38 rounded-8"
                                        placeholder="mobile number"
                                        value={mobile}
                                        onChange={formInputChangeHandler}
                                        required
                                        type="number"
                                        maxLength={10}
                                        autoFocus={numberError === 'mobile'}
                                    />
                                    <p className="absolute top-12 left-10 font-600">+91</p>
                                </div>
                            </div>

                            <div className="space-y-6">
                                <p className="font-700">Alternative Mobile Number</p>
                                <div className="relative">
                                    <Input
                                        id="alternative_mobile"
                                        className="p-10 pl-38 rounded-8"
                                        placeholder="alternative mobile number"
                                        value={alternative_mobile}
                                        onChange={formInputChangeHandler}
                                        required
                                        type="number"
                                        maxLength={10}
                                        autoFocus={numberError === 'alternative mobile'}
                                    />
                                    <p className="absolute top-12 left-10 font-600">+91</p>
                                </div>
                            </div>
                        </div>

                        <div className="flex items-center justify-between px-16 py-9 bg-neutral-9 rounded-b-8">
                            <p className="text-neutral-3 font-700 cursor-pointer" onClick={closeMe}>
                                Cancel
                            </p>
                            <button
                                className="btn--small primary-btn px-16 py-8"
                                onClick={saveRecipientHandler}
                                disabled={
                                    name.trim().length < 3 ||
                                    mobile.length !== 10 ||
                                    (alternative_mobile.length > 0 &&
                                        alternative_mobile.length !== 10)
                                }
                            >
                                Save Details
                            </button>
                        </div>
                    </div>
                    <style>
                        {`
                           .add-address-form input:valid {
                                border-color: black;
                            }
                        `}
                    </style>
                </div>
            </motion.div>
        </Hotkeys>
    );
};

export default AddRecipientModal;
